import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {VehicleSlider} from "../VehicleSlider/VehicleSlider";
import {BotTextMessage} from "./BotTextMessage";
import {calcTimeDiff} from "../../chatbotUtil";
import ReactMarkdown, {Components} from "react-markdown";
import {useLinkHandler} from "../../../app/hooks/useLinkHandler";
import {WidgetChatMessage} from "../../../api/generated";

interface BotGalleryMessageProps {
    index: number
    message: WidgetChatMessage
}

export const BotGalleryMessage: React.FC<BotGalleryMessageProps> = ({
                                                                        index,
                                                                        message
                                                                    }) => {

    const {openLink} = useLinkHandler();

    const components = {
        // @ts-ignore
        a: ({href, children}) => {
            return (
                <a
                    href={href}
                    style={{textDecoration: "underline"}}
                    onClick={(e) => openLink(href, true, e)}
                >
                    {children}
                </a>
            );
        },
    } as Components;

    if (message.vehicleDataList && message.vehicleDataList.length > 0) {
        return (
            <div
                key={index}
                className="mt-4 relative self-start w-full flex flex-col justify-between"
            >
                {message.message && (
                    <div className="flex flex-col w-[85%]">
                        <div className="rounded-xl border-[1px] text-gray-900 py-3 px-4 bg-white mb-5">
                            <div className="text-gray-900 overflow-wrap-anywhere whitespace-pre-wrap">
                                <ReactMarkdown components={components}>
                                    {message.message}
                                </ReactMarkdown>
                            </div>
                        </div>
                    </div>
                )}
                <VehicleSlider
                    vehicles={message.vehicleDataList!}
                />
                <div className="text-gray-500 ml-2 mt-1 text-[12px]"
                     suppressHydrationWarning>
                    {calcTimeDiff(message.timestamp)}
                </div>
            </div>
        );
    } else {
        return <BotTextMessage index={index} message={message}/>
    }
}
